.formLabel {
  font-size: 1.6rem;
  font-weight: 500;
  color: var(--color-white);
  padding: 0 0 var(--gap-regular) 0;
  display: flex;
  align-items: center;
}

.formLabelActiveFilter {
  color: var(--color-white);
}

.formLabelNonActiveFilter {
  color: var(--color-neutral-lightest);
}
